module.exports = __webpack_public_path__ + "img/check.84d4abbe.svg";